import React from "react";

import { isSameDay } from "date-fns";
import CakeIcon from "public/icons/cake.svg";

import { Theme, useMediaQuery } from "@mui/material";

import { IntroBadge } from "@/components/ui/intro-badge/IntroBadge";
import { SvgIcon } from "@/components/ui/svg-icon/SvgIcon";
import { ConditionalRender } from "@/lib/conditional-render/ConditionalRender";
import { clsxm } from "@/utils/tailwindMerge";

type PropTypes = {
  birthday?: number;
  isOnline?: boolean;
  isBirthdaySoon?: boolean;
  isNew?: boolean;
  hasIntroVideo?: boolean;
};

export const CardLabels: React.FC<PropTypes> = ({
  isOnline,
  isBirthdaySoon,
  birthday,
  isNew,
  hasIntroVideo,
}) => {
  const birthdayDate = birthday ? new Date(birthday) : null;

  const isBirthdayToday = birthdayDate
    ? isSameDay(
        new Date(
          new Date().getFullYear(),
          birthdayDate.getMonth(),
          birthdayDate.getDate(),
        ),
        new Date(),
      )
    : false;
  const down445Px = useMediaQuery((theme: Theme) => {
    return theme.breakpoints.down(445);
  });

  return (
    <div
      data-testid="cardLabels"
      className="absolute top-2 left-2 flex flex-col gap-1"
    >
      <ConditionalRender on={isBirthdaySoon || isBirthdayToday}>
        <div data-testid="bdLabel" className="flex bg-white rounded-lg px-2">
          <SvgIcon width={17} height={17}>
            <CakeIcon />
          </SvgIcon>
          <span
            className={clsxm(
              "w-fit text-pink text-xs font-extrabold h-4",
              "flex items-center",
            )}
          >
            {isBirthdayToday
              ? down445Px
                ? "TODAY"
                : "B-DAY TODAY"
              : down445Px
              ? "SOON"
              : "B-DAY SOON"}
          </span>
        </div>
      </ConditionalRender>
      <ConditionalRender on={hasIntroVideo}>
        <IntroBadge className="static w-min" />
      </ConditionalRender>
      <ConditionalRender on={isOnline}>
        <span
          data-testid="onlineLabel"
          className="w-fit rounded-lg bg-gradient-green text-white text-xs px-2 font-bold"
        >
          Online
        </span>
      </ConditionalRender>
      <ConditionalRender on={isNew}>
        <span
          data-testid="newLabel"
          className="w-fit rounded-lg bg-pink text-white text-xs px-2 font-bold"
        >
          NEW
        </span>
      </ConditionalRender>
    </div>
  );
};
